(function ($) {
    $(document).ready(function () {
        // $('.graphs').slick({ // Calls the Charts Slick Carousel
        //     rtl: true,
        //     infinite: false,
        //     dots: false,
        //     prevArrow: false,
        //     nextArrow: false
        // })
        $('.page-template-template-tco .tcu_popup .close').click(function(e) { 
            $('.tcu_popup').removeClass('show');

        });
            $('.tco_response .tco-tcf-inf').click(function(e) { 
            e.preventDefault();
            $('.tco_response .tco-tcf-tooltip').toggle();
        });
        $('.tco_response .open-popup').click(function(e) {  // Opens the change rates popup
            e.preventDefault();
            if(window.innerWidth < 768){
                $('.tco_response #Popup').css('display', 'block').css('bottom', -$(".tco_response #Popup").height()).animate({
                    bottom: 0
                });
            }
            else{
                $('.tco_response #Popup').fadeIn();
            }
            $('.page-template-template-tco #overlay').addClass('overlay');
            $('.tco_response #close-popup').focus();
        });
        $('.tco_response .tco_submit.tcu_button, #Popup #close-popup').click(function() {  // Close the change rates popup
            if(window.innerWidth < 768){
                $('.tco_response #Popup').animate({
                    bottom: -$(".tco_response #Popup").height() - 80
                });
                $('.page-template-template-tco #overlay').removeClass('overlay');
            }
            else{
                $('.tco_response #Popup').fadeOut('100',function(){
                    $('.page-template-template-tco #overlay').removeClass('overlay');
                });
            }
            

        });
        $('.tco_response #close-popup').on('keydown',function(e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
            }
        });
        $('.tco_response .endOfModal').on('keydown',function(e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
            }
        });

        $(document).keyup(function(event) {
            if(event.which===27){
                $('.tco_response #close-popup').click();
            } // 27 is the keycode for the Escape key
        });
        
        $('.tco_response #Popup .radio-wrap label').click(function() {
            $('.tcu_page form.tcu_form #depreciation_percentage').val($(this).prev().val());
            $('.tco_response .depreciation_percentage').html($(this).prev().val());
            $('.tcu_page .tco_submit').click();
            //$('.tco_response #close-popup').click();
        });
        $('.tco_response #Popup .radio-wrap input').on('keydown',function(event) {
            if((event.keyCode || event.which) == 13){
                $('.tcu_page form.tcu_form #depreciation_percentage').val($(this).val());
                $('.tco_response .depreciation_percentage').html($(this).val());
                $('.tcu_page .tco_submit').click();
                //$('.tco_response #close-popup').click();
            }
        });
        $('.tco_response .collapsible').click(function(){
            $(this).find('img').toggleClass('rotate');
            if($(this).hasClass('mobile')){
                $(this).find('span').toggleClass('hide');
            }
            $(this).toggleClass('active');
            $(this).parent().find('.collapsible-content').slideToggle();

            if($(this).hasClass('info-calc')){
                dataLayer.push({
                    'Category':'TCO calculator',
                    'Action':'show calc info',
                    'Label':$('.page-template-template-tco .tco_brands-slider input[name="model"]:checked').val(),
                    'event':'auto_event'
                });
                console.log('datalayer',dataLayer)
            }
            else if($(this).hasClass('how-calculated')){
                dataLayer.push({
                    'Category':'TCO calculator',
                    'Action':'show how the calc made',
                    'Label':$('.page-template-template-tco .tco_brands-slider input[name="model"]:checked').val(),
                    'event':'auto_event'
                });
                console.log('datalayer',dataLayer)
            }
        });
        var str = $('.tcu_each_word').text().split(" ");
        $('.tcu_each_word').empty();
        var cntr = 0;
        str.forEach(function(a) {
            if(a!='of'){
                cntr++;
                if(cntr == 1)
                    $('.tcu_each_word').append('<span class="first-letter">' + a.slice(0, 1) + '</span>' + a.slice(1));
                else 
                    $('.tcu_each_word').append('&nbsp;<span class="first-letter">' + a.slice(0, 1) + '</span>' + a.slice(1));    
            }
            else{
                $('.tcu_each_word').append('&nbsp;'+ a);
            }
        })
        
        setTimeout(function(){
            //$('.tcu_page .slider-container .pointer.high').attr('tabindex','0').attr('role','slider').attr('aria-label',$('.tcu_page .pointer-label.high').html());
            $('.tcu_page .slider-input:not(.first_payment) + .slider-container .pointer.high').attr({
                'tabindex':'0',
                'role':'slider',
                'aria-valuemin':'10000',
                'aria-valuemax':'40000',
                'aria-valuenow':parseInt($('.tcu_page .slider-input').val())*1000,
                'aria-describedby':'tcu_title',
                'aria-label':$('.tcu_page .pointer-label.high').html()
            });
            //$('.tcu_page .slider-container .pointer-label.high ').attr('aria-live','polite');
            $('.tcu_page .slider-container .pointer.high').on('keydown',function(event) {
                //console.log((event.keyCode || event.which))
                if((event.keyCode || event.which) == 38 || (event.keyCode || event.which) == 39){
                    event.preventDefault();
                    var currentVal = parseInt($('.tcu_page .slider-input').val());
                    if(currentVal >= 10 && currentVal < 40){
                        $('.tcu_page .slider-input').jRange('setValue', (currentVal + 5).toString());
                    }
                }
                else if((event.keyCode || event.which) == 37 || (event.keyCode || event.which) == 40){
                    event.preventDefault();
                    var currentVal = parseInt($('.tcu_page .slider-input').val());
                    if(currentVal > 10 && currentVal <= 40){
                        $('.tcu_page .slider-input').jRange('setValue', (currentVal - 5).toString());
                    }
                }
            });
        },500);
        
        
        if($('.tcu_page form.tcu_form select.tcu_select.tcu_brands').find( "option:selected" ).attr('data-brand')){
            dataLayer.push({
                'step':'choose-brand',
                'funnelName':'Calculator',
                'model':$('.tcu_page form.tcu_form select.tcu_select.tcu_brands').find( "option:selected" ).attr('data-brand'),
                'event':'changeStep'
            })
            //console.log(dataLayer);
        }
        $('.tcu_page form.tcu_form select.tcu_select.tcu_brands').change(function(){
            //$('.tcu_page form select.tcu_models').val('*בחר דגם');
            var selected = $(this).find( "option:selected" ).attr('data-brand');
            var cnt = 0;
            $('.tcu_page form.tcu_form select.tcu_select.tcu_models option').each(function(){
                if($(this).attr('data-brand') == selected){
                    $(this).show();
                    cnt++;
                }
                else{
                    $(this).hide();
                }
            });
            if(cnt == 1){
                $('.tcu_page form select.tcu_models').val($('.tcu_page form.tcu_form select.tcu_select.tcu_models option[data-brand="'+selected+'"]').html());
                $('.tcu_page form.tcu_form select.tcu_select.tcu_models option[data-brand="'+selected+'"]').attr('selected','selected');
                $('.tcu_models').trigger('change');
            }
            else{
                $('.tcu_page form select.tcu_models').val('* בחר דגם');
            }
            if(selected != 'none'){
                $('.tcu_page form.tcu_form select.tcu_select.tcu_models').removeAttr('disabled');
                $('.tcu_brands_error').hide(); 
                dataLayer.push({
                    'step':'choose-brand',
                    'funnelName':'Calculator',
                    'model':selected,
                    'event':'changeStep'
                })
                //console.log(dataLayer);
            }
            else{
                $('.tcu_page form.tcu_form select.tcu_select.tcu_models').attr('disabled','disabled');
                $('.tcu_brands_error').show(); 
            }
            //luEnableDisapleButton();
        });





        $('.tcu_page form.tcu_form select.tcu_select.tcu_models').change(function(){
            var selected = $(this).find( "option:selected" ).attr('data-brand');
            if(selected != 'none'){
                $('.tcu_models_error').hide(); 
                $('body.page-template-lu-calculator-template .tcu_page form.tcu_form .field_wrapper input#tcu_agree').removeAttr('disabled');
                dataLayer.push({
                    'step':'choose-type',
                    'funnelName':'Calculator',
                    'model':selected,
                    'subModel':$(this).val(),
                    'event':'changeStep'
                })
                //console.log(dataLayer);
            }
            else{
                $('.tcu_models_error').show(); 
                $('body.page-template-lu-calculator-template .tcu_page form.tcu_form .field_wrapper input#tcu_agree').attr('disabled','disabled');
            }
            //luEnableDisapleButton();
        });
        var tco_recalculate = false;
        $('.tco_recalculate').click(function(){
            dataLayer.push({
                'Category':'TCO calculator',
                'Action':'I want to calc again',
                'Label':$('.page-template-template-tco .tco_brands-slider input[name="model"]:checked').val(),
                'event':'auto_event'
            });
            console.log('datalayer',dataLayer);
            tco_recalculate = true;
            $('.tcu_after_calculate .tcu_back_link').click();
        });
        $('.tcu_after_calculate .tcu_back_link').click(function(e){
            if(!tco_recalculate){
                dataLayer.push({
                    'Category':'TCO calculator',
                    'Action':'go back',
                    'Label':$('.page-template-template-tco .tco_brands-slider input[name="model"]:checked').val(),
                    'event':'auto_event'
                });
                console.log('datalayer',dataLayer);
            }
            tco_recalculate = false;
            $('.tcu_after_calculate .tcu_header_left h2 b').html('');
            $('.tcu_after_calculate .tcu_response_header .tcu_full_time_savings .tcu_total').html('');
            $('.tcu_after_calculate .tcu_response_content .tcu_monthly_savings .tcu_total').html('');
            $('.tcu_after_calculate .tcu_response_content .tcu_yearly_savings .tcu_total').html('');
            $('.tcu_after_calculate').hide();
            $('body').removeClass('tco_response_show');
            $('.page-template-template-tco .ajax-loader').css('visibility','hidden');
            //$('.tcu_before_calculate form')[0].reset();
            //$('.slider-input').jRange('setValue', '10');
            //$('.tcu_page form.tcu_form select.tcu_select.tcu_models').attr('disabled','disabled');
            //$('.tcu_page .tcu_submit').addClass('disabled').attr('aria-disabled','true');
            $('.tcu_before_calculate').show();
            $('.page-template-template-tco .tcu_years_fieldset .radio_wrapper input[type="radio"]:checked, .page-template-template-tco .engine-block .radio_wrapper input[type="radio"]:checked').prop('checked',false);
            $('.page-template-template-tco .tcu_years_fieldset .radio_wrapper input[type="radio"]:first-of-type, .page-template-template-tco .engine-block .radio_wrapper label:first-of-type input[type="radio"]').prop('checked',true);
            if($('.page-template-template-tco .tco_brands-slider:not(.noslider)').length>0){
                $('.page-template-template-tco .tco_brands-slider').slick('slickGoTo', 1);
            }
            var min=10;
            $('.page-template-template-tco .slider-input-tco').jRange('setValue', min.toString());
        });
        $('body.page-template-lu-calculator-template .tcu_page form.tcu_form .radio_wrapper input[type="radio"]').on('click', function(e) {
            dataLayer.push({
                'step':'estimate-year',
                'funnelName':'Calculator',
                'model':$('.tcu_page form.tcu_form select.tcu_select.tcu_brands').val(),
                'subModel':$('.tcu_page form.tcu_form select.tcu_select.tcu_models').val(),
                'event':'changeStep'
            });
            //console.log(dataLayer);
            $('.tcu_before_calculate .error_result').hide();
        });
        $('body.page-template-template-tco .tcu_page form.tcu_form .radio_wrapper input[type="radio"]').on('click', function(e) {
            $('.tcu_before_calculate .error_result').hide();
        });
    });
    
    /*
    function luEnableDisapleButton(){
        if(luCalculatorValidForm($('.tcu_page form.tcu_form'))){
            $('.tcu_page .tcu_submit').removeClass('disabled').attr('aria-disabled','false');
        }
        else{
            $('.tcu_page .tcu_submit').addClass('disabled').attr('aria-disabled','true');
        }
    }*/
   
})(jQuery);


// WEBPACK FOOTER //
// assets/scripts/client/scripts.js